import { createFileRoute } from "@tanstack/react-router";
import { DashboardTemplatePage } from "@/features/dashboards/DashboardTemplatePage";

export const Route = createFileRoute("/_app/dashboards/template/$template")({
  component: Page,
});

function Page() {
  const { template } = Route.useParams();
  return <DashboardTemplatePage id={template} />;
}
